module.exports = __webpack_public_path__ + "static/media/folder.06e144d0.svg";